<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-捐赠项目-添加
    -->
    <el-dialog
    title="修改项目"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">绑定人员</div>
      
  
    <el-form-item label="人员设置" >
        <el-button size="small" type="primary" @click="addProcess" >新增人员</el-button>
        
        <div>选择人员，会自动添加该人员的上级,相同的用户最终只留下一个</div>
        <el-table :data="form"  border size="mini" style="width: 100%;margin-top: 20px;">
          <el-table-column prop="val" label="用户ID"    >
              <template v-slot="scope">
                <div class="d-s-c">
                  {{ scope.row.user.user_id }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="val" label="推荐人"    >
              <template v-slot="scope">
                <div class="d-s-c">
                  {{ scope.row.parent }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="val" label="用户昵称"  >
              <template v-slot="scope">
                <div class="d-s-c">
                  {{ scope.row.user.nickName }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="val" label="用户等级"  >
              <template v-slot="scope">
                <div class="d-s-c">
                  {{ scope.row.user.grade_name }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="val" label="分佣比例"  >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 350px;" type="number" v-model="scope.row.rate" 
                   placeholder="请输入分佣比例"></el-input>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="val" label="是否启用"  width="150">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-radio-group v-model="scope.row.status">
                      <el-radio :label="0">停用</el-radio>
                      <el-radio :label="1">启用</el-radio>
                    </el-radio-group>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delProcess(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
       <!--上传图片组件-->

       <GetUser :is_open="user_add" :multi="false" @close="closeDialogFuncUser"></GetUser>
  </div>
</el-dialog>
  
</template>

<script>
import EquipApi from '@/api/equip.js';
import Upload from '@/components/file/Upload';
import Uediter from '@/components/UE.vue';
import draggable from "vuedraggable";
var timestamp=new Date().toLocaleDateString();
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
       /*编辑器*/
       Uediter,
    /*图片上传*/
    Upload: Upload,
    draggable,
    GetUser,

  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
       /*富文本配置*/
       ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/

      form: {
        bannar:[],
        name: '',
        short_intro:"",
        intro:"",
        insti_id:0,
        money_target:0,
        rec_insti_id:0,
        type_id:1,
        note:"",
        p_time:new Date(timestamp),
        budget:[],
        plan:[],
        ability:"",
        about:"",
        d_note:"",//捐赠票据

        process:[],
        status:1,
        setting:{
          price:0,
        }


      },
      insti:{
        name:""
      },
      rec_insti:{
        name:""
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      isVideoUpload:false,
      cert_index:0,
      people_index:0,
      budget_index:0,
      isProductUpload:false,
      detail_index:0,
      open_insti:false,
      open_insti_rec:false,

      user_add:false,
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","equip_id",'type'],
  methods: {
     listSortBy(arr, field, sort = "asc") {
        arr.sort(function (a, b) {
          return a[field] - b[field]
      })
      if (sort === "desc") {
        arr.reverse()
      }
      return arr
    },

    deduplicate(arr) {
      var result = [];
      
      for (var i = 0; i < arr.length; i++) {
        var exists = false;
        
        for (var j = 0; j < result.length; j++) {
          if (parseInt(arr[i].user_id) ===parseInt( result[j].user_id)) {
            exists = true;
            break;
          }
        }
        
        if (!exists)
          result.push(arr[i]);
      }
      
      return result;
    },
    closeDialogFuncUser(e) {
        var self = this;
        var obj = e.params;
        if (e.type != 'error') {
            //获取上级，直到找不到
            EquipApi.getLogReferee({user_id: obj.user_id,equip_id:self.equip_id},true).then(res => {
                self.form =self.form.concat(res.data);
                //对数组去重
                self.form = this.deduplicate(self.form );
                self.form = this.listSortBy(self.form,'level','desc');
                console.log(' self.form', self.form)
                self.loading = false;

          })
          .catch(error => {});
            
        }
        this.user_add = false;
      },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      EquipApi.getLog({equip_id: self.equip_id},true).then(res => {
          self.form = res.data;
          self.form = this.listSortBy(self.form,'level','desc');
          self.loading = false;
        
        })
        .catch(error => {});

    },

   


    delProcess(index){
      this.form.splice(index,1)
    },
    addProcess(){
      this.user_add = true;
     
      },



     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;

          EquipApi.editLog({
            val:JSON.stringify(form),
            equip_id:self.equip_id
          }, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
      
  }
}
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

</style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/belong/log.vue